
import Slide1 from "./preview/slide-1.png";
import Slide2 from "./preview/slide-2.png";
import Slide3 from "./preview/slide-3.png";
import Slide4 from "./preview/slide-4.png";
import Template3Image from "./template-3-image.png";

import Template3Avatar from "./template-3-avatar.png";
import BaseTemplate from "../base";


class TextHeavyCarousel extends BaseTemplate {
  constructor() {
    super();
    this.id = "4";
    this.name = "Viral Carousel Template";
    this.url = "/ai/carousels/text-heavy-carousel";
    this.description = "This template is designed to help you create a carousel that can go viral on LinkedIn.";

    this.allow_new_elements = true;
    this.elable_elements_advanced_toolbar = true;
    this.common_settings = {
      elements: [
        {
          label: "Handle",
          type: "text",
          value: "@supergrowai",
          key: "handle",
        },
        {
          label: "Background Color",
          type: "color",
          key: "background_color",
          value: "#F5F2FF",
        },
        {
          label: "Primary Color",
          type: "color",
          key: "primary_color",
          value: "#000000"
        },
        {
          label: "Secondry Color",
          type: "color",
          key: "secondary_color",
          value: "#7C3BEC"
        },
        {
          label: "Tertiary Color",
          type: "color",
          key: "tertiary_color",
          value: "#667185"
        }
      ],
      swipe_indicator: {
        image: "",
        position: {
          x: 0,
          y: 0,
        }
      }
    }
    this.preview_images = [
      Slide1,
      Slide2,
      Slide3,
      Slide4,
    ]
    this.slides = [
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "multiline",
            value: "CREATE CONTENT EASILY DESPITE BEING BUSY AF.",
            max_words: 7,
            rows: 2,
            position: {
              x: 0,
              y: 0,
            },
            className: "text-5xl leading-none ",
            style: {
              color: {
                key: "primary_color"
              },
              height: {
                value: "150px"
              },
              width: {
                value: "344px"
              },
              fontSize: {
                value: "48px"
              },
              fontFamily: {
                value: "Bebas Neue"
              }
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            rows: 2,
            value: `Here are 5 tips to get you going. (Phase 1)`,
            max_words: 10,
            position: {
              x: 0,
              y: 150,
            },
            className: "text-base font-normal",
            style: {
              color: {
                key: "tertiary_color"
              },
              height: {
                value: "30px"
              },
              width: {
                value: "344px"
              },
              fontSize: {
                value: "16px"
              },
              fontFamily: {
                value: "Inter"
              }
            },
          },
          {
            label: "Image(Recommended size 400 x 200)",
            target_key: "image",
            type: "image",
            value: Template3Image,
            position: {
              x: 0,
              y: 200,
            },
            style: {
              height: {
                value: "200px"
              },
              width: {
                value: "344px"
              }
            },
            className: "object-cover w-full rounded-xl"
          },
          {
            label: "",
            target_key: "handle",
            type: "multiline",
            subtype: "common",
            rows: 2,
            value: {
              key: "handle",
            },
            max_words: 10,
            position: {
              x: 0,
              y: 420,
            },
            className: "text-sm font-bold",
            style: {
              color: {
                key: "secondary_color"
              },
              height: {
                value: "30px"
              },
              width: {
                value: "344px"
              },
              fontSize: {
                value: "16px"
              },
              fontFamily: {
                value: "Inter"
              }
            },
          },
        ],
        slide_type: "intro",
        className: "gap-4 px-8 py-4"
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            value: "TLDR",
            type: "multiline",
            rows: 2,
            max_words: 5,
            position: {
              x: 0,
              y: 0,
            },
            className: "text-3xl leading-none ",
            style: {
              color: {
                key: "primary_color"
              },
              height: {
                value: "30px"
              },
              width: {
                value: "344px"
              },
              fontSize: {
                value: "30px"
              },
              fontFamily: {
                value: "Bebas Neue"
              }
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `1. Intro
2. Stop Believing in Perfectionism
3. Focus on Quantity over Quality
4. Don't Use "Gear" as an Excuse
5. Talk to People What You're Up To
6. Stop Binge-Watching
7. Bonus-Tip`,
            max_words: 40,
            rows: 8,
            position: {
              x: 0,
              y: 45,
            },
            className: "text-sm font-normal leading-6",
            style: {
              color: {
                key: "primary_color"
              },
              height: {
                value: "300px"
              },
              width: {
                value: "344px"
              },
              fontSize: {
                value: "14px"
              },
              fontFamily: {
                value: "Inter"
              }
            },
          },
          {
            label: "",
            target_key: "handle",
            type: "multiline",
            subtype: "common",
            rows: 2,
            value: {
              key: "handle",
            },
            max_words: 10,
            position: {
              x: 0,
              y: 420,
            },
            className: "text-sm font-bold",
            style: {
              color: {
                key: "secondary_color"
              },
              height: {
                value: "30px"
              },
              width: {
                value: "344px"
              },
              fontSize: {
                value: "16px"
              },
              fontFamily: {
                value: "Inter"
              }
            },
          },
        ],
        slide_type: "middle",
        className: "gap-4 px-8 py-4"
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            value: "2nd Tip",
            type: "multiline",
            max_words: 5,
            rows: 2,
            position: {
              x: 0,
              y: 0,
            },
            style: {
              color: {
                key: "primary_color"
              },
              height: {
                value: "30px"
              },
              width: {
                value: "344px"
              },
              fontSize: {
                value: "30px"
              },
              fontFamily: {
                value: "Bebas Neue"
              }
            },
            className: "text-3xl leading-none ",
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `You may have a demanding job, a fast-paced career path, family, kids, dogs, and also other hobbies like fitness, music or gaming.

And it always seems like you just don't have enough time to create content and you just want it so badly, right?

I hear and I see you.`,
            rows: 4,
            max_words: 40,
            position: {
              x: 0,
              y: 40,
            },
            style: {
              color: {
                key: "primary_color"
              },
              height: {
                value: "350px"
              },
              width: {
                value: "344px"
              },
              fontSize: {
                value: "14px"
              },
              fontFamily: {
                value: "Inter"
              }
            },
            className: "text-sm font-normal leading-6",
          },
          {
            label: "",
            target_key: "handle",
            type: "multiline",
            subtype: "common",
            rows: 2,
            value: {
              key: "handle",
            },
            max_words: 10,
            position: {
              x: 0,
              y: 420,
            },
            className: "text-sm font-bold",
            style: {
              color: {
                key: "secondary_color"
              },
              height: {
                value: "30px"
              },
              width: {
                value: "344px"
              },
              fontSize: {
                value: "16px"
              },
              fontFamily: {
                value: "Inter"
              }
            },
          },
        ],
        slide_type: "middle",
        className: "gap-4 px-8 py-4"
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            value: "Stop Believing in Perfectionism",
            type: "multiline",
            rows: 2,
            max_words: 5,
            position: {
              x: 0,
              y: 0,
            },
            style: {
              color: {
                key: "primary_color"
              },
              height: {
                value: "30px"
              },
              width: {
                value: "344px"
              },
              fontSize: {
                value: "30px"
              },
              fontFamily: {
                value: "Bebas Neue"
              }
            },
            className: "text-3xl leading-none ",
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `This is the thing most people stumble upon in the very beginning.

"This picture is not perfect."
"The sound quality is not right."
"I need a better camera."

Get rid of the idea of perfection.
It only exists in your head and is something you'll never achieve.

If you can train your brain to do that, you'll start creating and immediately feel the beautiful sense of accomplishment.`,
            rows: 10,
            max_words: 40,
            position: {
              x: 0,
              y: 40,
            },
            style: {
              color: {
                key: "primary_color"
              },
              height: {
                value: "350px"
              },
              width: {
                value: "344px"
              },
              fontSize: {
                value: "14px"
              },
              fontFamily: {
                value: "Inter"
              }
            },
            className: "text-sm font-normal leading-6",
          },
          {
            label: "",
            target_key: "handle",
            type: "multiline",
            subtype: "common",
            rows: 2,
            value: {
              key: "handle",
            },
            max_words: 10,
            position: {
              x: 0,
              y: 420,
            },
            className: "text-sm font-bold",
            style: {
              color: {
                key: "secondary_color"
              },
              height: {
                value: "30px"
              },
              width: {
                value: "344px"
              },
              fontSize: {
                value: "16px"
              },
              fontFamily: {
                value: "Inter"
              }
            },
          },
        ],
        slide_type: "middle",
        className: "gap-4 px-8 py-4"
      },
      {
        elements: [
          {
            label: "Image(Recommended size 256x256)",
            target_key: "image",
            type: "image",
            value: Template3Avatar,
            position: {
              x: 0,
              y: 0,
            },
            style: {
              height: {
                value: "auto"
              },
              width: {
                value: "344px"
              }
            },
            className: "overflow-hidden rounded-full h-28 w-28 ring-1 ring-gray-200"
          },
          {
            label: "Title",
            target_key: "title",
            type: "multiline",
            value: "Hi. My name is Vijay Tiwari.",
            rows: 2,
            max_words: 5,
            position: {
              x: 0,
              y: 120,
            },
            style: {
              color: {
                key: "primary_color"
              },
              height: {
                value: "30px"
              },
              width: {
                value: "344px"
              },
              fontSize: {
                value: "16px"
              },
              fontFamily: {
                value: "Inter"
              },
              fontWeight: {
                value: "bold"
              }
            },
            className: "text-base font-bold",
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `• Founder and Agency owner
• CEO at Senler Media GmbH in Zurich, Switzerland
• Dad to Twins`,
            rows: 4,
            max_words: 20,
            position: {
              x: 0,
              y: 150,
            },
            style: {
              color: {
                key: "primary_color"
              },
              height: {
                value: "100px"
              },
              width: {
                value: "344px"
              },
              fontSize: {
                value: "14px"
              },
              fontFamily: {
                value: "Inter"
              }
            },
            className: "text-sm font-normal leading-6",
          },
          {
            label: "CTA Text",
            type: "multiline",
            target_key: "cta_text",
            value: "Follow me",
            max_words: 2,
            rows: 1,
            position: {
              x: 0,
              y: 270,
            },
            style: {
              color: {
                value: "#FFFFFF"
              },
              backgroundColor: {
                key: "secondary_color"
              },
              fontSize: {
                value: "14px"
              },
              fontFamily: {
                value: "Inter"
              },
              width: {
                value: "103px"
              },
              height: {
                value: "71px"
              },
            },
            className: "px-4 py-2 text-sm font-bold rounded-full"
          },
          {
            label: "",
            target_key: "handle",
            type: "multiline",
            subtype: "common",
            rows: 2,
            value: {
              key: "handle",
            },
            max_words: 10,
            position: {
              x: 0,
              y: 420,
            },
            className: "text-sm font-bold",
            style: {
              color: {
                key: "secondary_color"
              },
              height: {
                value: "30px"
              },
              width: {
                value: "344px"
              },
              fontSize: {
                value: "16px"
              },
              fontFamily: {
                value: "Inter"
              }
            },
          },

        ],
        slide_type: "outro",
        className: "gap-4 px-8 py-4"
      }
    ]
  }

  setCommonSettings(settings) {
    this.common_settings = settings;
  }

  renderSlide(slide, index, currentSlide, carouselLength, commonSettings, updateSlideElementPosition, updateSlideElementSize, setCurrentSlideElement, previewMode) {
    return (
      this.renderSlideV2(slide, index, currentSlide, carouselLength, commonSettings, updateSlideElementPosition, updateSlideElementSize, setCurrentSlideElement, previewMode)
    )
  }
}



export default TextHeavyCarousel;
